/**
 * @author Angel Labrada
 * @since v0.0.1
 * @date 20/12/21
 */
import React, {memo, useEffect} from 'react';
import PropTypes from 'prop-types';
import {Form} from 'antd';
import ClientsApiService from '@/modules/clients/services/ClientsApiService';
import {useGetOneClient} from '@/modules/clients/hooks/useClients';
import {useClientFilter} from '@/hooks/useClientFilter';
import AsyncSelect from '@/components/AsyncSelect';

const clientId = (value) => {
  return (typeof value === 'object') ? value?._id : value;
};

const AuditorAuditsSelectClients = ({value, filters, isViewMode, ...props}) => {
  const {data} = useGetOneClient(clientId(value));
  const { setCurrentClient, setCurrentClientEntity, currentEstablishment } = useClientFilter();

  useEffect(() => {
    if(!currentEstablishment) {
      setCurrentClient({_id: data?._id, space: data?.space});
      setCurrentClientEntity(data);
    }
  }, [currentEstablishment, data, setCurrentClient, setCurrentClientEntity]);

  if (isViewMode) {
    return (
      <>
        {data?.name || 'N/A'}
      </>
    );
  }

  return (
    <AsyncSelect
      queryKey={'clients-select'}
      filters={filters}
      service={ClientsApiService}
      customMethod='/ms-core/api/structures/worker/clients/search'
      value={value}
      deferFetchUntilOpen={true}
      sort={{ code: 1 }}
      queryConfig={{ refetchOnWindowFocus: false }}
      className="custom-select"
      additionalParams={
        {
          forceSize: true,
          useProjections: true,
          projections: {
            name: 1
          }
        }
      }
      {...props}
    />
  );
};

AuditorAuditsSelectClients.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  filters: PropTypes.object,
  isViewMode: PropTypes.func,
};

export default memo(AuditorAuditsSelectClients);

export const renderSelectClient = ({formItemProps, form, field, ...props}) => {
  const onChange = (value = {}) => {
    form.setFieldsValue({
      [field.key]: value,
      establishment: null,
      service: null,
      auditor: null,
    });
  };

  const rules = [{
    required: field?.required,
    messaged: 'required',
  }];

  return (
    <Form.Item {...formItemProps} required={field?.required} rules={rules}>
      <AuditorAuditsSelectClients onChange={onChange} {...props} placeholder={field?.placeholder} />
    </Form.Item>
  );
};

/**
 * cellRender
 * */
/**
 * This is not a component,
 * it is a function to render the Code component in a table cell
 * @param {String} text this is the value of the dataIndex of the table (we will ignored in this case)
 * @param {object} entity this is entity type
 * */
export const renderCustomCompany = (text, entity) => {
  return (
    <AuditorAuditsSelectClients value={text} entity={entity} isViewMode={true}/>
  );
};
